interface TasksSidebarProps {
  tasks: any[];
  selectedTask: any;
  onTaskSelect: (task: any) => any;
  taskContainerCounts?: { [key: string]: number };
}

export function TasksSidebar({ tasks, selectedTask, onTaskSelect, taskContainerCounts = {} }: TasksSidebarProps) {
  return (
    <div className="flex flex-col rounded-lg px-2 py-3 w-full min-h-full bg-white border-r border-gray-200">
      <h2 className="text-xl font-semibold mb-3">My Tasks</h2>
      <div className="flex-grow overflow-y-auto mb-4">
        <ul className="space-y-2">
          {tasks.map((task, index) => {
            const isSelected = task === selectedTask;
            return (
              <div
                key={index}
                className={`rounded ${isSelected ? 'bg-slate-200 hover:bg-slate-200' : 'hover:bg-gray-50'}`}
              >
                <li
                  className="flex items-start justify-between rounded cursor-pointer p-2"
                  onClick={() => onTaskSelect(task)}
                >
                  <span className="text-sm text-gray-800 line-clamp-2 pr-2 flex-1 min-w-0">
                    {task}
                  </span>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    {taskContainerCounts[task] !== undefined && (
                      <span
                        style={{
                          display: 'flex',
                          padding: '2px 10px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: '10px',
                          borderRadius: '9999px',
                          border: '1px solid rgba(255,255,255,0.00)',
                          fontSize: '12px',
                          background: isSelected ? '#0F172A' : '#F1F5F9',
                          color: isSelected ? 'white' : '#0F172A',
                          minWidth: '28px',  
                          height: '24px',
                        }}
                      >
                        {taskContainerCounts[task]}
                      </span>
                    )}
                    <button className="p-1 hover:bg-gray-100 rounded">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 12L10 8L6 4"
                          stroke="#6B7280"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </li>
              </div>
            );
          })}
        </ul>
      </div>
      <div className="mt-auto">
        <button 
          disabled
          className="flex items-center px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-lg text-sm text-gray-400 cursor-not-allowed whitespace-nowrap max-w-full overflow-hidden text-ellipsis opacity-60"
        >
          <svg
            className="mr-2"
            width="18"
            height="18"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 11.3334L3.33333 12.6667L6 10M2 4.66671L3.33333 6.00004L6 3.33337M8.66667 4.00004H14M8.66667 8.00004H14M8.66667 12H14"
              stroke="#9CA3AF"
              strokeWidth="1.33"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          View All Tasks
        </button>
      </div>
    </div>
  );
}
